import { Component, OnInit, OnDestroy } from '@angular/core';
import { PreviousUrlService } from '../services/previous-url.service';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
  selector: 'app-delegate-home-page',
  templateUrl: './delegate-home-page.component.html',
  styleUrls: ['./delegate-home-page.component.scss']
})
export class DelegateHomePageComponent implements OnInit {
  public isDefaultTheme: boolean;
  public activeTheme: any;
  public text: string;
  public isLifeFileTheme: boolean;
  public previousLink: string;
  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService, 
    public themeService: ThemeService,
    private previousUrl: PreviousUrlService
    ) {}

  

  async ngOnInit() {
    this.previousLink = this.previousUrl.getPreviousUrl();
    if (this.previousLink === "/log-in") {
      window.location.reload();
    }
    this.activeTheme = this.themeService.active
    if (this.activeTheme.name != 'defaultTheme') {
      this.isDefaultTheme = false;
    }
    switch(this.activeTheme.name) {
      case 'lifeFile':
        this.text = 'Life File';
        break;
      case 'pemTheme':
        this.text = 'PEM';
        break;
      case 'palmersTheme':
        this.text = 'Palmers Solicitors';
        break;
    }
  }

  

}
